$(function () {
  initSwiperPromoSection();
  initSwiperCollectionNav();
  initSwiperCollectionCard();
  initProductGallery();
  initFigureZoom();
  initStoryGallery();
  initBackgroundVideo();
  initFancyboxVideo();
});

function initSwiperPromoSection() {
  new Reswiper(".promo-swiper", {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: true,
  });
}

function initStoryGallery() {
  var storyGallery = new Reswiper(".story-gallery", {
    spaceBetween: 4,
    slidesPerView: "1.4705",
    watchOverflow: true,
    loop: false,
    speed: 800,
    breakpointsInverse: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 8,
        slidesPerView: "2.189",
      },
      1200: {
        spaceBetween: 8,
        slidesPerView: "3.189",
      },
    },
  });
}

function initFancyboxVideo() {
  var $container = $('[data-fancybox="video"]');
  if ($container.length > 0) {
    $container.fancybox({
      youtube: {
        showinfo: 0,
      },
    });
  }
}

function initBackgroundVideo() {
  $(".jquery-background-video").bgVideo({
    fadeIn: 2000,
  });
}

function initSwiperCollectionNav() {
  new Reswiper(".collection-navigation-swiper", {
    slidesPerView: 6,
    // centeredSlides: true,
    spaceBetween: 40,
    watchOverflow: true,
    breakpoints: {
      960: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 3.5,
        spaceBetween: 6,
        scrollbar: {
          dragSize: 35,
        },
      },
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      dragSize: 150,
      draggable: true,
    },
  });

  if (
    $(".collection-navigation-swiper .swiper-scrollbar").hasClass(
      "swiper-scrollbar-lock"
    )
  ) {
    $(".collection-navigation-swiper .swiper-wrapper").addClass("disabled");
  }
}

function initProductGallery() {
  const numberOfSlides = document.querySelectorAll(
    ".gallery-thumbs .swiper-slide"
  ).length;

  const galleryThumbs = new Reswiper(".gallery-thumbs", {
    direction: "vertical",
    slidesPerView: 6,
    watchOverflow: true,
    slideToClickedSlide: numberOfSlides > 6 ? true : false,
    watchSlidesProgress: true,
    spaceBetween: 10,
    loopedSlides: 50,
    loop: numberOfSlides > 6 ? true : false,
    nested: true,
    navigation: {
      nextEl: ".gallery-thumbs-wrapper .swiper-button-next",
    },
    on: {
      init:
        numberOfSlides > 6
          ? function () {
              this.$el.addClass("thumbs-no-active");
            }
          : "",
    },
  });

  const galleryTop = new Reswiper(".gallery-top", {
    slidesPerView: 1,
    loop: numberOfSlides > 6 ? true : false,
    loopedSlides: 50,
    watchSlidesProgress: true,
    thumbs: {
      swiper: numberOfSlides <= 6 ? galleryThumbs : null,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });

  if (numberOfSlides > 6) {
    galleryThumbs.controller.control = galleryTop;
    galleryTop.controller.control = galleryThumbs;
  }
}

function initFigureZoom() {
  if (window.innerWidth > 960) {
    $(".figure-zoom").on("mousemove", function (e) {
      let zoomer = e.currentTarget;
      e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
      e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
      x = (offsetX / zoomer.offsetWidth) * 100;
      y = (offsetY / zoomer.offsetHeight) * 100;
      zoomer.style.backgroundPosition = x + "% " + y + "%";
    });
  }
}

function initSwiperCollectionCard() {
  const buildSwiperSlider = (sliderElm) => {
    const sliderIdentifier = sliderElm.dataset.id;
    let cardSlider = new Reswiper(`#${sliderElm.id}`, {
      spaceBetween: 2,
      effect: "fade",
      touchStartPreventDefault: false,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `.swiper-button-next-${sliderIdentifier}`,
        prevEl: `.swiper-button-prev-${sliderIdentifier}`,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        dragSize: 40,
        draggable: true,
      },
    });

    sliderElm.addEventListener("mouseenter", () => {
      if (cardSlider.activeIndex === 0) {
        cardSlider.slideTo(1, 800, false);
      }
    });

    sliderElm.addEventListener("mouseleave", () => {
      if (cardSlider.activeIndex !== 0) {
        cardSlider.slideTo(0, 800, false);
      }
    });
    return cardSlider;
  };

  const allSliders = document.querySelectorAll(
    ".product__content .swiper.swiper-container"
  );
  allSliders.forEach((slider) => buildSwiperSlider(slider));
}
